import type {ReactElement} from 'react';
import {createElement} from 'react';
import type {EmailMakerControl, EmailMakerControlProps} from '../../right-panel-registry.types';
import styles from './mobile-sheet-group.module.scss';

/**
 * Shows several right-panel rows together in one mobile sheet. The bottom bar only re-renders on selection, not on
 * edits, so rows that depend on each other (a toggle and the rows it hides) must share a sheet to stay in sync.
 */
export function makeMobileSheetGroup(controls: readonly EmailMakerControl[]): EmailMakerControl {
  return function MobileSheetGroup({component, hideSectionHeading}: EmailMakerControlProps): ReactElement {
    return <div className={styles.group}>{controls.map((control, index) => createElement(control, {component, hideSectionHeading, key: index}))}</div>;
  };
}
